import React, { MouseEventHandler } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { triggerDebuggerAndThrow } from "../../utils/debugging-utils";
import WorkoutPicker from "../Modals/WorkoutPicker";
import Icons from "./Icons";

type Props = {
  onClick: MouseEventHandler;
  show: boolean;
  options: string[];
  onAdd: Function;
  onInvite: Function;
  onAddSuperset: Function;
  onAddExercise: Function;
} & RouteComponentProps;

const FloatingActionButtonComponent = ({
  onClick,
  show,
  location,
  options,
  onAdd,
  onInvite,
  onAddSuperset,
  onAddExercise,
}: Props) => {
  const { ic_add_white, ic_add, ic_invite, ic_edit, ic_infinity } = Icons;
  const currentPath = location.pathname.replace("/", "");
  const [showWorkouts, setShowWorkouts] = React.useState(false);

  type ActionProps = (args: {
    option: string;
    i: number;
    FabActions: any[];
    FabIcons: any[];
  }) => JSX.Element;

  const generateActionMenu: ActionProps = ({ option, i, FabActions, FabIcons }) => (
    <div
      key={i}
      onClick={() => {
        FabActions[i]();
        return onClick({} as any);
      }}
      style={{ position: "relative" }}
    >
      <span
        onClick={FabActions[i]}
        style={{
          position: "absolute",
          padding: 5,
          borderRadius: "5px",
          backgroundColor: "#ffffff",
          color: "var(--text-primary)",
          minWidth: "60px",
          textAlign: "center",
          visibility: show ? "visible" : "hidden",
          bottom: show ? (i ? 160 : i * 90 + 90) : -(i * 90 + 90),
          transitionDuration: "0.3s",
          left: -(option.length + 75),
          fontSize: 10,
        }}
      >
        {option}
      </span>
      <span
        onClick={FabActions[i]}
        style={{
          position: "relative",
          visibility: show ? "visible" : "hidden",
          bottom: show ? (i ? 160 : i * 90 + 90) : -(i * 90 + 90),
          transitionDuration: "0.3s",
          // right: '10px',
          height: "28px",
          width: "28px",
          borderRadius: "50%",
          backgroundColor: "#ffffff",
          padding: "8px 10px",
          cursor: "pointer",
          zIndex: 3,
        }}
      >
        <img
          style={{ width: "15px", marginBottom: "2px" }}
          alt={option}
          title={option}
          src={FabIcons[i]}
        />
      </span>
    </div>
  );

  const generateClientActionMenu = () => {
    if (!options || options.length === 0) return null;
    const FabIcons = [ic_add, ic_invite];
    const FabActions = [onAdd, onInvite];
    return options.map((option: string, i: number) =>
      generateActionMenu({ option, i, FabActions, FabIcons })
    );
  };
  const generateExerciseActionMenu = () => {
    if (!options || options.length === 0) return null;
    const FabIcons = [ic_add];
    const FabActions = [onAdd];
    return options.map((option: string, i: number) =>
      generateActionMenu({ option, i, FabActions, FabIcons })
    );
  };
  const generateWorkoutActionMenu = () => {
    if (!options || options.length === 0) return null;
    // Declare Icons array:
    const FabIcons = [ic_add, ic_edit];
    // Declare Actions array:
    const FabActions = [onAdd, (_e: React.MouseEvent) => setShowWorkouts(true)];
    return options.map((option: string, i: number) =>
      generateActionMenu({ option, i, FabActions, FabIcons })
    );
  };
  const generateSetActionMenu = () => {
    // const workoutId = props.match.params.id;
    if (!options || options.length === 0) return null;
    // Declare Icons array:
    const FabIcons = [ic_add, ic_infinity];
    // Declare Actions array:
    const FabActions = [onAddExercise, onAddSuperset];
    return options.map((option: string, i: number) =>
      generateActionMenu({ option, i, FabActions, FabIcons })
    );
  };

  return (
    <>
      <div id="FaB">
        <div style={{ marginBottom: "2px", padding: "10px 16px" }} onClick={onClick}>
          <span>
            <img
              style={{
                width: "15px",
                transform: show ? "rotate(225deg)" : "rotate(0deg)",
                transitionDuration: "0.3s",
              }}
              alt="menu"
              src={ic_add_white}
            />
          </span>
        </div>

        <div>
          <span>
            {currentPath === "clients"
              ? window.innerWidth > 700
                ? generateSetActionMenu()
                : generateClientActionMenu()
              : currentPath === "exercises"
              ? generateExerciseActionMenu()
              : currentPath === "workouts"
              ? window.innerWidth > 700
                ? generateSetActionMenu()
                : generateWorkoutActionMenu()
              : /workouts\//.test(currentPath)
              ? generateSetActionMenu()
              : /schedules/.test(currentPath) || (options && onAddSuperset && onAddExercise)
              ? generateSetActionMenu()
              : null}
          </span>
        </div>
      </div>

      <div id="FaB-bg" style={{ visibility: show ? "visible" : "hidden" }} onClick={onClick} />
      <WorkoutPicker
        show={showWorkouts}
        onHide={() => setShowWorkouts(!showWorkouts)}
        hasSelector={true}
        setShowAddWorkout={triggerDebuggerAndThrow}
      />
    </>
  );
};

export default withRouter(FloatingActionButtonComponent);
